module.exports = __webpack_public_path__ + "static/media/sell_finish_service_rent_4.dc98eb7f.jpg";